import { COUPON_STATUS } from "@/constants/coupon";
import useAppStore from "@/context/store";
import { getCounpons } from "@/services";
import { isGdMerged } from "@/utils/gaoding";
import { safeParse } from "@/utils/safeParse";
import useRequest from "@/utils/useReq";
import { useMemoizedFn } from "ahooks";
import { useEffect } from "react";
import { create } from "zustand";
export const HB_AVATAR_RED_TIP_DATA = "HB_AVATAR_RED_TIP_DATA";

export const useRedTipState = create(() => ({
  /**优惠券提示 */
  couponTip: false,
  couponIds: [],
  /**未支付订单提示 */
  orderTip: false,
}));

/**
 * 获取本地数据
 */
function getLocalData() {
  return typeof window === "undefined"
    ? {}
    : safeParse(localStorage.getItem(HB_AVATAR_RED_TIP_DATA) || "{}") || {};
}

export const useInitRedTipState = () => {
  const { user, unPayOrders, couponNum } = useAppStore(
    ({ user, unPayOrders, couponNum }) => ({ user, unPayOrders, couponNum })
  );

  const { data: couponIds } = useRequest(
    async () => {
      if (couponNum) {
        let res;
        if (isGdMerged(user)) {
          return [];
        } else {
          res = await getCounpons({ status: COUPON_STATUS.GOT });
        }

        if (res?.list?.length) {
          useRedTipState.setState({ couponIds: res.list.map((el) => el.id) });
          return res.list.map((el) => el.id);
        }
      }
    },
    {
      refreshDeps: [couponNum],
    }
  );

  useEffect(() => {
    // 用户已点击知道的优惠券ID
    const { readCouponIds = [], readOrderIds = [] } = getLocalData();

    // 优惠券提醒
    if (couponIds?.length) {
      for (let i = 0; i < couponIds.length; i++) {
        if (!readCouponIds.includes(couponIds[i])) {
          useRedTipState.setState({
            couponTip: true,
            couponIds,
          });
          break;
        }
      }
    }

    if (unPayOrders.length) {
      for (let i = 0; i < unPayOrders.length; i++) {
        const order = unPayOrders[i];
        if (!readOrderIds.includes(order.id)) {
          useRedTipState.setState({
            orderTip: true,
          });
          break;
        }
      }
    }
  }, [couponNum, unPayOrders, couponIds]);
};

// 维护用户已点击知道的优惠券ID与订单ID
export const useLocalStorageRedTip = () => {
  const { readCouponIds = [], readOrderIds = [] } = getLocalData();

  const setLocalStorage = (value) => {
    localStorage.setItem(
      HB_AVATAR_RED_TIP_DATA,
      JSON.stringify({
        ...(safeParse(localStorage.getItem(HB_AVATAR_RED_TIP_DATA)) || {}),
        ...value,
      })
    );
  };

  const setReadCouponIds = (ids = []) => {
    setLocalStorage({ readCouponIds: ids });
  };

  const setReadOrderIds = (ids = []) => {
    setLocalStorage({ readOrderIds: ids });
  };

  return {
    readCouponIds,
    readOrderIds,
    setReadCouponIds,
    setReadOrderIds,
  };
};

export const useVipCardRedTip = () => {
  const { couponIds, couponTip, orderTip } = useRedTipState(
    ({ couponIds, couponTip, orderTip }) => ({
      couponIds,
      couponTip,
      orderTip,
    })
  );

  const unPayOrders = useAppStore((s) => s.unPayOrders);

  const { setReadCouponIds, setReadOrderIds } = useLocalStorageRedTip();
  const onCouponClick = useMemoizedFn((evt) => {
    evt.stopPropagation();
    // 未使用优惠券设为已读
    setReadCouponIds(couponIds);

    // 取消红点提示
    useRedTipState.setState({
      couponTip: false,
    });
  });

  const onOrderClick = useMemoizedFn(
    (evt) => {
      evt.stopPropagation();
      // 未支付订单设为已读
      setReadOrderIds(unPayOrders.map((el) => el.id));

      // 取消红点提示
      useRedTipState.setState({
        orderTip: false,
      });
    },
    [setReadOrderIds, unPayOrders]
  );

  return {
    couponTip,
    orderTip,
    onCouponClick,
    onOrderClick,
  };
};
